import Dashboard from "layouts/dashboard";
import UploadTB from "layouts/tables";
import Statements from "layouts/billing";
import DataCleaner from "layouts/data-cleaner";
import { IoHome } from "react-icons/io5";
import { IoCloudUploadOutline } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { IoSparkles } from "react-icons/io5";

const routes = [
  {
    type: "collapse",
    name: "Overview",
    key: "dashboard",
    route: "/dashboard",
    icon: <IoHome size="15px" color="inherit" />,
    component: Dashboard,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Data Cleaner",
    key: "data-cleaner",
    route: "/data-cleaner",
    icon: <IoSparkles size="15px" color="inherit" />,
    component: DataCleaner,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Upload TB",
    key: "upload",
    route: "/upload",
    icon: <IoCloudUploadOutline size="15px" color="inherit" />,
    component: UploadTB,
    noCollapse: true,
  },
];

export default routes;
